import { render, staticRenderFns } from "./DropdownPosition.vue?vue&type=template&id=1a86d024"
import script from "./DropdownPosition.vue?vue&type=script&lang=js"
export * from "./DropdownPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports